<ng-container *ngIf="viewActive">
  <div class="d-flex flex-row justify-content-between text-center pb-1">
    <div class="d-flex flex-row justify-content-around w-100">
      <div class="btn-group">
        <div
          class="btn btn-primary"
          mwlCalendarPreviousView
          [view]="viewMode"
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChanged($event)"
        >
          Previous
        </div>
        <div
          class="btn btn-outline-secondary"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChanged($event)"
        >
          Today
        </div>
        <div
          class="btn btn-primary"
          mwlCalendarNextView
          [view]="viewMode"
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChanged($event)"
        >
          Next
        </div>
      </div>
      <div class="">
        <h3>{{ viewDate | calendarDate: viewMode + "ViewTitle":"en" }}</h3>
      </div>
      <div class="btn-group">
        <div
          class="btn btn-primary"
          (click)="setViewMode(CalendarView.Month)"
          [class.active]="viewMode === CalendarView.Month"
        >
          Month
        </div>
        <div
          class="btn btn-primary"
          (click)="setViewMode(CalendarView.Week)"
          [class.active]="viewMode === CalendarView.Week"
        >
          Week
        </div>
        <div
          class="btn btn-primary"
          (click)="setViewMode(CalendarView.Day)"
          [class.active]="viewMode === CalendarView.Day"
        >
          Day
        </div>
      </div>
    </div>

    <div class="d-inline-block text-nowrap">
      <i role="button"
        class="p-1 mr-1 fa fa-window-minimize"
        (click)="closeCalendar$.emit({clearFilter:false})"
        title="Keep date filter / hide calendar">
      </i>
      <i role="button"
        class="p-1 fa fa-window-close"
        (click)="closeCalendar$.emit({clearFilter:true})"
        title="Clear date filter / hide calendar">
      </i>
    </div>

  </div>

  <ng-container [ngSwitch]="viewMode">
    <!-- no need for calendar day view because the task list table will already be filtered to show day details
      mwl-calendar-day-view
      *ngSwitchCase="CalendarView.Day"
      [viewDate]="viewDate"
      [events]="eventsById|values"
      [dayStartHour]="0"
      [dayEndHour]="0"
      (eventClicked)="onCalendarEventSelected($event.event)"
    >
    </mwl-calendar-day-view-->
    <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="eventsById | values"
      [dayStartHour]="0"
      [dayEndHour]="0"
      (eventClicked)="onCalendarEventSelected($event.event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="eventsById | values"
      (eventClicked)="onCalendarEventSelected($event.event)"
      (dayClicked)="onCalendarDaySelected($event.day)"
      [cellTemplate]="dayOfMonthTemplate"
    >
    </mwl-calendar-month-view>

    <ng-template
      #dayOfMonthTemplate
      let-day="day"
      let-locale="locale"
      let-openDay="openDay"
      let-tooltipPlacement="tooltipPlacement"
      let-highlightDay="highlightDay"
      let-unhighlightDay="unhighlightDay"
      let-eventClicked="eventClicked"
      let-tooltipTemplate="tooltipTemplate"
      let-tooltipAppendToBody="tooltipAppendToBody"
      let-tooltipDelay="tooltipDelay"
      let-trackByEventId="trackByEventId"
      let-validateDrag="validateDrag"
    >
      <div
        class="cal-cell-top"
        [attr.aria-label]="
          { day: day, locale: locale } | calendarA11y: 'monthCell'
        "
      >
        <span aria-hidden="true">
          <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{
            day.badgeTotal
          }}</span>
          <span class="cal-day-number">{{
            day.date | calendarDate: "monthViewDayNumber":locale
          }}</span>
        </span>
      </div>
      <div class="cal-events" *ngIf="day.events.length > 0">
        <div
          *ngFor="let event of day.events; trackBy: trackByEventId"
          [ngStyle]="{ backgroundColor: event.color?.primary }"
          [ngClass]="event?.cssClass"
          (mouseenter)="highlightDay.emit({ event: event })"
          (mouseleave)="unhighlightDay.emit({ event: event })"
          [mwlCalendarTooltip]="
            event.title | calendarEventTitle: 'monthTooltip':event
          "
          [tooltipPlacement]="tooltipPlacement"
          [tooltipEvent]="event"
          [tooltipTemplate]="tooltipTemplate"
          [tooltipAppendToBody]="tooltipAppendToBody"
          [tooltipDelay]="tooltipDelay"
          mwlDraggable
          [class.cal-draggable]="event.draggable"
          dragActiveClass="cal-drag-active"
          [dropData]="{ event: event, draggedFrom: day }"
          [dragAxis]="{ x: event.draggable, y: event.draggable }"
          [validateDrag]="validateDrag"
          [touchStartLongPress]="{ delay: 300, delta: 30 }"
          (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })"
          [attr.aria-hidden]="{} | calendarA11y: 'hideMonthCellEvents'"
          class="p-1"
        >
          <ng-container [ngSwitch]="event.meta.task?.type">
            <i
              *ngSwitchCase="'scout'"
              class="fa fa-1x fa-drafting-compass text-primary"
            ></i>
            <i
              *ngSwitchCase="'path test'"
              class="fa fa-1x fa-map-marked text-success"
            ></i>
            <i
              *ngSwitchCase="'drive test'"
              class="fa fa-1x fa-car-side text-info"
            ></i>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
